import "./App.css";
import QuoteBox from "./Components/QuoteBox";

function App() {
  return (
    <div className="App">
      <QuoteBox />
    </div>
  );
}

export default App;
